import { QueryKeys } from "@/data/globals";
import { CmsImage } from "@/db/cmsImagesRepository";
import { useQuery } from "@tanstack/react-query";

export default function useCmsImageItems() {
  const query = useQuery<CmsImage[]>({
    queryKey: [QueryKeys.CMS_ITEMS_IMAGES],
    queryFn: async () => {
      const res = await fetch("/api/cms/items/images");
      return (await res.json()) as CmsImage[];
    }
  });

  return query;
}
